import {Inject, Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {WindowRefService} from "../window-ref.service";
import {APP_CONFIG, AppConfig} from "../../config/app.config";
import {NavigationStart, Router} from "@angular/router";
import {DateMonthPipe} from "./pipes/date-month.pipe";
import {PriceFormatPipe} from "./pipes/price-format.pipe";

@Injectable({providedIn: 'root'})
export class PageTitleService {
  private type: string;
  private params: any;

  constructor(
    @Inject(APP_CONFIG) private appConfig: AppConfig,
    private titleService: Title,
    private window: WindowRefService,
    private router: Router,
    private datePipe: DateMonthPipe,
    private priceFormat: PriceFormatPipe,
  ) {}

  private translations = this.appConfig.translates.common;

  public setTitle(type: string, params) {
    this.type = type;
    this.params = params;

    switch (type) {
      case 'avia':
        this.setAviaListingTitle();
        break;
      case 'aviaDetails':
        this.setAviaDetailsTitle();
        break;
      case 'aviaReservation':
        this.setAviaReservationTitle();
        break;
      case 'error':
        this.setErrorTitle();
        break;
      default:
        this.titleService.setTitle('HT.kz');
    }
  }

  private setAviaListingTitle() {
    const price = this.params.params.price ? `${this.params.params.price} | ` : '';
    const departure = this.params.params.departure;
    const destination = this.params.params.destination;
    const dateFrom = this.params.params.dateFrom;
    let dateTo = '';
    if (this.params.params.dateTo) {
      dateTo = ` - ${this.params.params.dateTo}`;
    }
    const tourists = `, ${this.params.params.tourists}`;

    this.titleService.setTitle(`${price}${departure} - ${destination} ${dateFrom}${dateTo}${tourists}`);

    const navBarTitle = this.window.document.querySelector('.nav-bar .title');
    if (!navBarTitle) {
      return;
    }

    navBarTitle.innerHTML = `${departure} - ${destination} <span class="subtitle">${dateFrom}${dateTo}${tourists}</span>`;
  }

  private setAviaDetailsTitle() {
    const departure = this.params.params.departure;
    const destination = this.params.params.destination;
    const dateFrom = this.params.params.dateFrom;

    let dateTo = '';
    if (this.params.params.dateTo) {
      dateTo = ` - ${this.params.params.dateTo}`;
    }
    const tourists = `, ${this.params.params.tourists}`;
    const price = this.params.params.price;

    this.titleService.setTitle(`${price} | ${departure} - ${destination} ${dateFrom}${dateTo}${tourists}`);

    if (this.params.params.priceAfterBonuses) {
      const pwb = this.window.nativeWindow.document.querySelector('.price-with-bonuses');
      if (pwb) {
        pwb.classList.remove('hidden');
        const value = pwb.querySelector('.value');
        if (value) {
          value.innerHTML = this.priceFormat.transform(this.params.params.priceAfterBonuses);
        }
      }
    }

    const navBarTitle = this.window.document.querySelector('.nav-bar .title');
    if (!navBarTitle) {
      return;
    }

    navBarTitle.innerHTML = `${departure} - ${destination} <span class="subtitle">${dateFrom}${dateTo}${tourists}</span>`;
  }

  private setAviaReservationTitle() {
    const departure = this.params.params.departure;
    const destination = this.params.params.destination;
    const dateFrom = this.params.params.dateFrom;

    let dateTo = '';
    if (this.params.params.dateTo) {
      dateTo = ` - ${this.params.params.dateTo}`;
    }
    const tourists = `, ${this.params.params.tourists}`;

    const navBarTitle = this.window.document.querySelector('.nav-bar .title');
    if (!navBarTitle) {
      return;
    }

    navBarTitle.innerHTML = `${departure} - ${destination} <span class="subtitle">${dateFrom}${dateTo}${tourists}</span>`;
  }

  public beforeRequestTitle(event) {
    if (!(event instanceof NavigationStart)) return;

    const url = event.url;
    const urlTree = this.router.parseUrl(url);
    const queryParams = urlTree.queryParams;

    if (url.startsWith('/new/search/avia')) {
      let tourists = `${queryParams['adults']} ${this.translations.adultsShort}`;
      if (queryParams['children'] > 0) {
        let childStr = queryParams['children'] > 1 ? this.translations.childShort : this.translations.childrenShort;

        tourists = `${tourists}, ${queryParams['children']}${childStr}`;
      }
      this.setTitle('avia', {
        params: {
          departure: queryParams['departure'] || '',
          destination: queryParams['destination'] || '',
          dateFrom: this.datePipe.transform(queryParams['dateFrom'], 'short') || '',
          dateTo: this.datePipe.transform(queryParams['dateTo'], 'short') || '',
          tourists: tourists,
        }
      });
    }
  }

  private setErrorTitle() {
    const navBarTitle = this.window.document.querySelector('.nav-bar .title');
    if (!navBarTitle) {
      return;
    }

    navBarTitle.innerHTML = this.appConfig.translates.errors.somebodyError;
  }
}
